<template>
    <Paper class="barcode-merge">
        <m-table
            ref="RegistrationTable"
            :pageTotal="pageTotal"
            :tableData="listData"
            :config="tableConfig"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @onSearchDataChange="onSearchDataChange"
            @getTableConfigList="getTableConfigList">
            <template v-slot:table-module-btn-right>
                <el-button type="primary" size="mini" @click="search" :loading="loading" icon="el-icon-search" >
                    {{ $translate('lang.E3202101260004', {defaultText: '查 询'}) }}
                </el-button>
                <el-tooltip class="sn-search-default-button"  effect="dark" placement="bottom"
                :content="$translate('lang.E2202402030018', { defaultText: '导出' })" >
                    <reportExport #default="{ submit }" reportCode="">
                        <el-button icon="el-icon-upload2" size="mini" @click="searchExport(submit)"></el-button>
                    </reportExport>
                </el-tooltip>
            </template>
            <template v-slot:search-isReadTheEnd>
                <div class="checkbox">
                    {{$translate('lang.E3202101280012', { defaultText: '是否读取最终节点' })}}：
                    <el-checkbox v-model="searchData.isReadTheEnd" true-label="1" false-label=""></el-checkbox>
                    </div>
            </template>
            <template v-slot:page-module-btn>
                <div>
                    <el-button size="mini" type="primary" @click="batchOperation">
                        {{$translate('lang.E3202301040034', { defaultText: '批量查询导出' })}}
                    </el-button>
                    <el-button class="sn-search-reset-button" size="mini" @click="toLeadXsl()">
                        {{$translate('lang.E2202402270011', { defaultText: '导入' })}}
                    </el-button>
                </div>
            </template>
        </m-table>
        <multipleImport ref="multiple"
            :templateExport="templateExport"
            :searchData="searchData"
            v-bind="multipleProps"
            @uploadImport="uploadImport">
        </multipleImport>
    </Paper>
</template>

<script>

import Paper from '@/components/core/paper/Paper';
import mTable from '@/modules/sn/components/IdentityComponentCopy/Main';
import { searchBarcodeSwapOverseas, uploadProcess, importProcess, uploadRecordSearchByPage } from '@/modules/sn/api/lcbsManagement.js';
import { searchByDictCodes } from '@/modules/sn/api/systemManagementApi.js';
import { tableConfig } from './tableConfig.js';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';
import multipleImport from '../component/multipleImport';
import reportExport from '@/components/lots/reportExportPlugin';
const EXPORT_API = '/api-sn/lbcs/barcodeFullProcessTracking/export'; // 通用导出接口路径

export default {
    name: 'processSearchOverseas',
    components: { Paper, mTable, multipleImport, reportExport },
    data() {
        return {
             OUTBOUND_INBOUND_TYPE: {// 出入库类型-对照
                'IN': this.$translate('lang.E3202103030037', { defaultText: '入库' }),
                'OUT': this.$translate('lang.E3202103030038', { defaultText: '出库' })
            },
            pageTotal: 0, // 总条数
            listData: [], // 列表数据
            searchData: {
                isReadTheEnd: ''
            }, // 搜索框数据
            tableConfig: {}, // 表格配置
            exportColumns: [], // 导出行
            listExportParams: {},
            dictObj: {},
            loading: false,
            multipleProps: {
                title: this.$translate('lang.E3202301040034', { defaultText: '批量查询导出' }),
                btnText: this.$translate('lang.E2202402030017', { defaultText: '查询导出' })
            },
            templateExp: {
                exportUrl: '/api-sn/lbcs/barcodeSwapOverseas/searchTemplate',
                exportName: this.$translate('lang.E2202402030012', { defaultText: 'LBCS条码全流程批量查询模板(新).xls' }),
                titleText: this.$translate('lang.E2202402030013', { defaultText: '批量查询模板下载(新)' })
            },
            templateLead: {
                exportUrl: '/api-sn/lbcs/barcodeSwapOverseas/template',
                exportName: this.$translate('lang.E2202402030014', { defaultText: 'LBCS条码全流程批量导入模板.xlsx' }),
                titleText: this.$translate('lang.E2202402030015', { defaultText: '批量导入模板下载(新)' })
            },
            templateExport: {
                exportParams: {},
                exportFlag: 1,
                type: 'get'
            }
        };
    },
    created() {
        this.tableConfig = this.setTableConfig();
        this.getSearchByPage();
         this.handleDicts();
    },
    computed: {
        ...mapGetters(['currentTenant', 'user'])
    },
    methods: {
        handleDicts() {
            const params = {
                dictCodes: 'SN_LBCS_SHIP_ORG_TYPE,Y_N'
            };
            searchByDictCodes(params).then(res => {
                if (res && res.data) {
                    Object.keys(res.data).forEach(key => {
                        const obj = {};
                        res.data[key].forEach(item => {
                            obj[item.code] = item.name;
                        });
                        this.dictObj[key] = obj;
                    });
                }
            });
        },
        // 列配置
        getTableConfigList(data) {
            this.exportColumns = data;
        },
        // 动态设置配置行
        setTableConfig() {
            const newConfig = cloneDeep(tableConfig);
            return newConfig;
        },
        onSearchDataChange(data) {
            this.searchData = { ...this.searchData, ...data };
        },
        pageChange(pageNo) {
            this.tableConfig.page.pageNo = pageNo;
            const params = this.handleSearchData();
            this.getData(params, 'isTrigger');
        },
        sizeChange(pageSize) {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = pageSize;
            const params = this.handleSearchData();
           this.getData(params, 'isTrigger');
        },
        // 查询
        search() {
            this.tableConfig.page.pageNo = 1;
            this.tableConfig.page.pageSize = 10;
            const params = this.handleSearchData();
            this.getData(params, 'isTrigger');
        },
        handleSearchData() {
            const params = {
                ...this.searchData,
                pageNo: this.tableConfig.page.pageNo,
                pageSize: this.tableConfig.page.pageSize
            };
            if (params.billTime) {
                params['billDateStart'] = params['billTime'];
                params['billDateEnd'] = params['billTime'].substring(0, 10) + ' 23:59:59';
            };
            if (params.opTime) {
                params['opDateStart'] = params['opTime'];
                params['opDateEnd'] = params['opTime'].substring(0, 10) + ' 23:59:59';
            };
            delete params.billTime;
            delete params.opTime;
            Object.keys(params).forEach(item => {
                if (!params[item]) {
                    delete params[item];
                }
            });
            return params;
        },
        getData(params, isTrigger) {
            if (!params.barcodeNo && !params.billNo &&
            !params.batchNo) {
                this.$message.warning(this.$translate('lang.E2202402030016', { defaultText: '条码字符串、单据号、批次号不能同时为空' }));
                return;
            };
            this.listExportParams = cloneDeep(params);
            this.loading = true;
            searchBarcodeSwapOverseas(params).then(res => {
                if (res.code === '0') {
                    this.listData = res.data.list;
                    const { SN_LBCS_SHIP_ORG_TYPE, Y_N } = this.dictObj;
                    this.listData.forEach(item => {
                        item.shipTypeDict = SN_LBCS_SHIP_ORG_TYPE[item.shipperType];
                        item.recTypeDict = SN_LBCS_SHIP_ORG_TYPE[item.consigneeType];
                        item.isEndDict = Y_N[item.isEnd];
                        item.inoutType = this.OUTBOUND_INBOUND_TYPE[item.inoutType];
                        if (item.processFlag === 'Y') {
                            item.processFlag = this.$translate('lang.E2202402270016', { defaultText: '执行成功' });
                        }
                        if (item.processFlag === 'N') {
                            item.processFlag = this.$translate('lang.E2202402270017', { defaultText: '执行失败' });
                        }
                    });
                    this.pageTotal = res.data.totalCount;
                    if (res.data.list.length && isTrigger) {
                        this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                    }
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        toLeadXsl() {
            this.templateExport = { ...this.templateExport, ...this.templateLead };
            this.multipleProps.title = this.$translate('lang.E3202102260006', { defaultText: '批量导入' });
            this.multipleProps.btnText = this.$translate('lang.E2202402270011', { defaultText: '导入' });
            this.$refs.multiple.orderImportC();
        },
        batchOperation() {
            this.templateExport = { ...this.templateExport, ...this.templateExp };
            this.multipleProps.title = this.$translate('lang.E3202301040034', { defaultText: '批量查询导出' });
            this.multipleProps.btnText = this.$translate('lang.E2202402030017', { defaultText: '查询导出' });
            this.$refs.multiple.orderImportC();
        },
        uploadImport(form, submit) {
            if (this.multipleProps.btnText === this.$translate('lang.E2202402030017', { defaultText: '查询导出' })) {
                uploadProcess(form).then(res => {
                    if (res && +res.code === 0) {
                        const params = {
                            EXPORT_API,
                            barcodeBatchNo: res.data
                        };
                        submit(params);
                        this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                    }
                });
            } else {
                importProcess(form).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(this.$translate('lang.EXC202102260005', { defaultText: '导入成功' }));
                        this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                    }
                });
            }
        },
        searchExport(submit) {
            const params = {
                EXPORT_API,
                ...this.listExportParams
            };
            if (!params.barcodeNo && !params.billNo &&
            !params.batchNo) {
                this.$message.warning(this.$translate('lang.E2202402030016', { defaultText: '条码字符串、单据号、批次号不能同时为空' }));
                return;
            };
            if (!this.listData.length) {
                this.$message.warning(this.$translate('lang.EXC202101260002', { defaultText: '暂无导出数据,请重新设置查询条件' }));
                return;
            };
            submit(params);
        },
        async getSearchByPage() {
            const params = {
                'uploadBy': this.user.userCode,
                'importFlag': 'SWAP',
                'pageNo': 1,
                'pageSize': 15
            };
           const res = await uploadRecordSearchByPage(params);
           if (res.code === '0') {
                this.tableConfig.searchList.searchTxt.forEach(item => {
                    if (item.value === 'batchNo') {
                        item.options = res.data.list.map(obj => ({
                            label: obj.batchId,
                            value: obj.batchId
                        }));
                    }
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
.barcode-merge {
    /deep/ .el-table {
        height: calc(100vh - 220px) !important;
    }
}
.border-btn{
    border-color: #4285f5;
    color: #4285f5;
}
.checkbox{
    font-size: 14px;
    line-height: 28px;
}
</style>
